import { AddFraseReport } from "app/screens/residents/show/AddFraseReport";

export default function AddFraseReportPage() {
  return <AddFraseReport />;
}
